export default __webpack_public_path__ + "static/media/sorryicon.33dfe39a.png";